"use client";

import * as React from "react";

import { createSVGIcon } from "../../util";

export const EcoFriendly = createSVGIcon(
  <>
    <path
      d="M1.03203 1C1.03203 1 -0.244364 15.4456 13.3173 15.8537C13.3173 15.8537 17.2263 3.04034 1.03203 1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1L15.1463 17.9756"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.968 1C29.968 1 31.2444 15.4456 17.6827 15.8537C17.6827 15.8537 13.7737 3.04034 29.968 1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 1L15.1464 18.0913V22.9268"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53662 22.9277H26.4634L25.7326 27.879H5.75478L4.53662 22.9277Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.36584 27.8789L9.15275 39.196H22.4733L24.3415 27.8789"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EcoFriendly",
  { viewBox: "0 0 31 40", titleAccess: "EcoFriendly", fill: "none" }
);
